import './assets/css/base.less'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/devTool'

// 导入 vant 组件库
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import '@vant/touch-emulator'; // 桌面端自动将 mouse 事件转换成对应的 touch 事件，使得组件能够在桌面端使用
Toast.setDefaultOptions({ duration: 2000, overlay: true });
Toast.setDefaultOptions('loading', { duration: 0, });
Vue.use(Vant);

Vue.config.productionTip = false

// 请求接口
import { http, imgUpload } from './http'
Vue.prototype.$http = http
Vue.prototype.$imgUpload = imgUpload

// 全局过滤器
import { formatAmount } from './utils/filters'
Vue.filter("formatAmount", (amount) => formatAmount(amount))

// 多语言
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// const langList = ['zh_cn', 'vi_vi', 'en_us', 'es_spa', 'ms_my', 'id_id',]
const langList = ['zh_cn', 'id_id']
let lang = localStorage.getItem("lang")
if (!lang || !langList.includes(lang)) lang = "id_id"
localStorage.setItem('lang', lang)
Vue.prototype.locale_lang = lang
const i18n = new VueI18n({
  globalInjection: true,
  locale: lang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'zh_cn': require('./lang/zh_cn.json'),
    // 'vi_vi': require('./lang/vi_vi.json'),
    // 'en_us': require('./lang/en_us.json'),
    // 'es_spa': require('./lang/es_spa.json'),
    // 'ms_my': require('./lang/ms_my.json'),
    'id_id': require('./lang/id_id.json'),
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
